import { render, staticRenderFns } from "./PortfolioStockLotWidget.vue?vue&type=template&id=f5c3c654&scoped=true&"
import script from "./PortfolioStockLotWidget.vue?vue&type=script&lang=js&"
export * from "./PortfolioStockLotWidget.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioStockLotWidget.vue?vue&type=style&index=0&id=f5c3c654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c3c654",
  null
  
)

export default component.exports